import { LoanBalance } from "../types/loan-balance";

export const loanBalanceEmpty: LoanBalance = {
  isFetching: false,
  refetch: async () => {},
  data: {
    progress: 0,
    loanAmount: 0,
    totalBudget: 0,
    pendingDraws: 0,
    totalFees: 0,
    fundedToDate: 0,
    remainingBalance: 0,
    interestBalances: {
      totalInterest: 0,
      totalBaseRate: 0,
      totalDefaultInterest: 0,
    },
    totalLoanCost: 0,
  },
};
